import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  &:first-of-type {
    padding-top: 0.5rem;
  }
`

export const Header = styled.div`
  display: flex;
  gap: 1.2rem;
  flex: 1;
`

export const ProductTitleLink = styled.a`
  display: block;

  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

export const ImageWrapper = styled.div`
  width: 11rem;
  aspect-ratio: 4/5;
`

export const LoadingImage = styled(Skeleton)`
  height: 100%;
  display: block;
`

export const EmptyImage = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.skeleton.baseColor};
`

export const ProductImage = styled(ResponsiveImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;

  .safari-lower-than-15 & {
    max-width: 40vw;
    object-fit: contain;
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem 0;
  flex: 1;

  .product-type {
    font-size: 1.2rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.hover};
  }

  .seo-caption {
    font-size: 1.2rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.hover};
  }
`

export const ProductDetails = styled.div<{ hasSeoCaption?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  /* With a seo_caption above, match the tight title↔caption gap; otherwise keep the default separation from the title block */
  margin-top: ${({ hasSeoCaption }) => (hasSeoCaption ? '0' : '0.5rem')};
`

export const Price = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const DetailsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const RemoveButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.primary};
  font-style: italic;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
